export default function DownloadCTA() {
  return (
    <section id="download" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="relative rounded-3xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20flowing%20gradient%20background%20with%20warm%20teal%20green%20and%20coral%20orange%20tones%2C%20soft%20smooth%20curves%2C%20minimalist%20modern%20digital%20art%2C%20clean%20futuristic%20aesthetic%2C%20no%20text%20elements%2C%20gentle%20color%20transitions&width=1400&height=600&seq=91-download-bg&orientation=landscape"
            alt="下载背景"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-primary-900/90 to-primary-800/80"></div>

          <div className="relative z-10 py-16 md:py-20 px-6 md:px-12 text-center">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-background-50 mb-4">
              立即下载91浏览器
            </h2>
            <p className="text-background-200/80 max-w-xl mx-auto mb-10 leading-relaxed">
              选择您的设备平台，开始安全流畅的浏览体验。最新版本 v8.0，适配 Android 7.0+ 和 iOS 13.0+
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-5">
              <a
                href="#"
                className="flex items-center gap-3 px-8 py-4 bg-background-50 text-primary-700 font-heading font-semibold rounded-xl hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-android-line text-2xl"></i>
                <div className="text-left">
                  <p className="text-sm leading-tight">Android 版下载</p>
                  <p className="text-xs text-foreground-500 font-normal">v8.0 · 45MB</p>
                </div>
              </a>
              <a
                href="#"
                className="flex items-center gap-3 px-8 py-4 bg-background-50/15 backdrop-blur-sm text-background-50 font-heading font-semibold rounded-xl border border-background-50/30 hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apple-line text-2xl"></i>
                <div className="text-left">
                  <p className="text-sm leading-tight">iOS 版下载</p>
                  <p className="text-xs text-background-300 font-normal">v8.0 · App Store</p>
                </div>
              </a>
            </div>

            <p className="mt-6 text-xs text-background-300">
              也支持通过各大应用商店搜索"91浏览器"下载
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}